import { ApiClientError, GetOutstandingBalance } from '@raydiant/api-client-js';
import raydiant from '../clients/raydiant';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';
import { UseQueryOptions } from 'react-query';

export default function useOutstandingBalance(
  options: UseQueryOptions<GetOutstandingBalance, ApiClientError> = {},
) {
  const query = useProtectedQuery<GetOutstandingBalance, ApiClientError>(
    keys.outstandingBalance(),
    () => raydiant.getOutstandingBalance(),
    {
      enabled: false,
      // Cache the current user profile for the lifetime of the page.
      staleTime: Infinity,
      cacheTime: Infinity,
      retry: false,
      ...options,
    },
  );

  const outStandingBalanceData = query.data?.response;

  return {
    ...query,
    data: outStandingBalanceData,
  };
}
